import {
  AppThemeType,
  CompanySiteSlice,
  Creator,
  ThemeModeType,
} from 'store/types';
import { CompanyData } from 'types/company';

export const createCompanySiteSlice: Creator<CompanySiteSlice> = (set) => ({
  company: undefined,
  site: undefined,
  companyModalOpen: false,
  siteModalOpen: false,
  companyData: undefined,
  selectedSite: undefined,
  mobileCompanySiteDrawerOpen: false,
  themeMode: 'light',
  appTheme: 'light',
  setCompanyModalOpen: () => set(() => ({ companyModalOpen: true })),
  setCompanyModalClosed: () => set(() => ({ companyModalOpen: false })),
  setSiteModalOpen: () => set(() => ({ siteModalOpen: true })),
  setSiteModalClosed: () => set(() => ({ siteModalOpen: false })),
  setCompanyData: (data?: CompanyData) => set(() => ({ companyData: data })),
  setSelectedSite: (site?: string) => set(() => ({ selectedSite: site })),
  setMobileCompanySiteDrawerOpen: () =>
    set(() => ({ mobileCompanySiteDrawerOpen: true })),
  setMobileCompanySiteDrawerClosed: () =>
    set(() => ({ mobileCompanySiteDrawerOpen: false })),
  setThemeMode: (theme: ThemeModeType) => set(() => ({ themeMode: theme })),
  setAppTheme: (theme: AppThemeType) => set(() => ({ appTheme: theme })),
});
